export default __webpack_public_path__ + "static/media/top.5906bbf3.png";